import { render, staticRenderFns } from "./ParentId.vue?vue&type=template&id=7f0ebf8e&lang=pug"
import script from "./ParentId.vue?vue&type=script&lang=js"
export * from "./ParentId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports